import PropTypes from 'prop-types';
import { Avatar, Badge } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import { formatTimeAgo } from '../utils';
import messages from '../messages';

const MessageBubble = ({ message }) => {
  const intl = useIntl();
  const time = formatTimeAgo(message.timestamp, intl.locale);
  const isSupport = message.sender === 'support';

  return (
    <article
      className={`learner-support-comment${
        isSupport ? ' learner-support-comment--staff' : ''
      }`}
    >
      <header className="learner-support-comment__header">
        <Avatar
          size="md"
          src={message.userImage || undefined}
          alt=""
          className="learner-support-comment__avatar"
        />
        <div className="learner-support-comment__author">
          <span className="learner-support-comment__name">
            {message.senderName || '—'}
          </span>
          {isSupport && (
            <Badge variant="soft" color="primary">
              {intl.formatMessage(messages.supportBadge)}
            </Badge>
          )}
        </div>
        <span className="learner-support-comment__time">{time}</span>
      </header>
      <div className="learner-support-comment__body">{message.content}</div>
    </article>
  );
};

MessageBubble.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    sender: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    timestamp: PropTypes.string.isRequired,
    userImage: PropTypes.string,
    senderName: PropTypes.string,
  }).isRequired,
};

export default MessageBubble;
